const parser = typeof window === 'undefined' ? null : new DOMParser();

export const getTextContentFromHTML = (str: string): string =>
  parser ? parser.parseFromString(str, 'text/html').body.textContent || '' : '';

export const removeNodeFromHTML = (htmlString: string, selector: string): string | null => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlString, 'text/html');
  const element = doc.querySelector(selector);
  if (element) {
    element.remove();
  }

  // eslint-disable-next-line no-restricted-properties
  return !!getTextContentFromHTML(doc.body.innerHTML).trim() ? doc.body.innerHTML : null;
};
